import BreadCrumbs from "./breadcrumbs"
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { operations as breadcrumboperation } from "../../../state/features/common/globalsearch";
import { selectors as headerSelector, operations as headeroperations } from "../../../state/features/header";
import { LINKSECTION } from "../../../const/linksection";
import { ApplicationLinkResult } from "../../../interfaces/applicationlink";
import linkServices from "../../../services/applicationlinkservice";
import { IcontainerProps } from "./breadcrumbsinterface";
import { ICartContextType } from "../ShoppingCartPromo/shoppingcartpromointerface";
import { useCartContext } from "../shoppingcart";

const BreadCrumbsContainer = (props: IcontainerProps) => {
    const dispatch = useDispatch();
    const dispatchsetBreadCrumRedirect =
        breadcrumboperation.dispatchBreadCrumbRedirect(dispatch);
    const navigate = useNavigate();
    const [breadcrumItems, setBreadcrumItems] = useState<[]>([]);
    const { headercurrentuser, applinks }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
        applinks: headerSelector.applinks(state),
    }));
    const dispatchAppLinks = headeroperations.dispatchsetAppLinks(dispatch);
    const { isGuestUser }: ICartContextType = useCartContext();
    const [guestUserUrlLink, setGuestUserUrlLink] = useState<any>({});

    const { t } = useTranslation();
    
    useEffect(() => {
        retrieveApplicationLinks();
    }, [])


    useEffect(() => {
        if (props.isShoppingCart && !props.showPuchoutHistory && !props.showKomatsuCreditHistory && !props.pageName) {
            const items: any = [
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    role: "Home",
                    onClick: _onBreadcrumbItemClicked
                },
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    role: "Part Store",
                    onClick: _onBreadcrumbPartStoreItemClicked,
                },
                { text: t(RESOURCE.MyK_BreadcrumbHeader_Cart), key: t(RESOURCE.MyK_BreadcrumbHeader_Cart), role: "Cart", isCurrentItem: true },
            ];

            setBreadcrumItems(items);
        }
        else if (props.showPuchoutHistory)
        {
            const items: any = [
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    role: "Home",
                    onClick: _onBreadcrumbItemClicked
                },
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    role: "Part Store",
                    onClick: _onBreadcrumbPartStoreItemClicked,
                },
                {
                    text: t(RESOURCE.MyK_Label_SC_Puchout_History),
                    key: t(RESOURCE.MyK_Label_SC_Puchout_History),
                    role: "Puchout History",
                    isCurrentItem: true
                },
            ];

            setBreadcrumItems(items);
        }
        else if (props.showKomatsuCreditHistory) {
            const items: any = [
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    role: "Home",
                    onClick: _onBreadcrumbItemClicked
                },
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    role: "Part Store",
                    onClick: _onBreadcrumbPartStoreItemClicked,
                },
                {
                    text: t(RESOURCE.MyK_Label_SC_Komatsu_Credit_History),
                    key: t(RESOURCE.MyK_Label_SC_Komatsu_Credit_History),
                    role: "Komatsu Credit History",
                    isCurrentItem: true
                },
            ];

            setBreadcrumItems(items);
        }
        else if (!props.pageName) {
            const items: any = [
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    role: "Home",
                    onClick: _onBreadcrumbItemClicked
                },
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    role: "Part Store",
                    onClick: _onBreadcrumbPartStoreItemClicked 
                },
                { text: t(RESOURCE.MyK_BreadcrumbHeader_Cart), key: t(RESOURCE.MyK_BreadcrumbHeader_Cart), role: "Cart", onClick: props.shoppingcartOnClick },
                { text: t(RESOURCE.MyK_BreadcrumbHeader_Checkout), key: t(RESOURCE.MyK_BreadcrumbHeader_Checkout), role: "Checkout", isCurrentItem: true },
            ];

            setBreadcrumItems(items);
        }

        if (props.pageName && props.pageName == 'OT') {
            const items: any = [
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    role: "Home",
                    onClick: _onBreadcrumbItemClicked
                },
                {
                    text: "Order Tracking",
                    key: t(RESOURCE.MyK_BreadcrumbHeader_PartsStore),
                    role: "Order Tracking",
                    isCurrentItem: true
                }
            ];

            setBreadcrumItems(items);
        }

        if (props.pageName && props.pageName == 'OH') {
            const items: any = [
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    role: "Home",
                    onClick: _onBreadcrumbItemClicked
                },
                {
                    text: t(RESOURCE.Myk_Label_OrderHistory_OrderHistory),
                    key: t(RESOURCE.Myk_Label_OrderHistory_OrderHistory),
                    role: "Order History",
                    isCurrentItem: true
                }
            ];

            setBreadcrumItems(items);
        }
        if (props.pageName && props.pageName == 'OD') {
            const items: any = [
                {
                    text: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    key: t(RESOURCE.MyK_BreadcrumbHeader_Home),
                    role: "Home",
                    onClick: _onBreadcrumbItemClicked
                },
                {
                    text: t(RESOURCE.Myk_Label_OrderHistory_OrderHistory),
                    key: t(RESOURCE.Myk_Label_OrderHistory_OrderHistory),
                    role: "Order History",
                    onClick: _onBreadcrumbOHItemClicked
                },
                {
                text: t(RESOURCE.MyK_Label_OrderHistory_OrderDetails),
                key: t(RESOURCE.MyK_Label_OrderHistory_OrderDetails),
                    role: "Order Details",
                    isCurrentItem: true
                },
            ];

            setBreadcrumItems(items);
        }
    }, [props.isShoppingCart, applinks, props?.showKomatsuCreditHistory, props?.showPuchoutHistory])

    const retrieveApplicationLinks = () => {
        const userId = headercurrentuser?.azureADId;
        if (userId != undefined && userId != "") {
            linkServices
                .getLinksForMenus(userId, "Web-Footer,Web-PreFooter")
                .then((response) => {
                    if (response != null) {
                        let linkResult = response as ApplicationLinkResult; 
                        dispatchAppLinks(linkResult);
                    } else {
                        getFromBlobOnfailure();
                    }
                })
                .catch((e: any) => {
                    getFromBlobOnfailure();
                });
        }
    };
    const getFromBlobOnfailure = async () => {
        let userTypestr =
            headercurrentuser?.usertype?.nm != undefined &&
                headercurrentuser?.usertype?.nm != null
                ? headercurrentuser?.usertype?.nm
                : "Customer";
        await linkServices
            .getLinksForBlob(userTypestr, "Applicationlink")
            .then((response) => {
                if (response != null) {
                    let linkResult = response as ApplicationLinkResult;
                    dispatchAppLinks(linkResult);
                }
            });
    };

    const GetGuestUserUrlLink = () => {
        fetch("/auth/GetGuestUserUrlLink")
            .then((response) => response.json())
            .then((json) => {
                setGuestUserUrlLink(json);
            })
            .catch((error) => {
                setGuestUserUrlLink({});
            });
    };

    useEffect(() => {
        GetGuestUserUrlLink();
    }, [])

    const _onBreadcrumbPartStoreItemClicked = (item: any) => {

        let prefooterLinksResult = applinks?.links?.filter(
            (item: { section: string }) => item?.section == LINKSECTION.WebPreFooter
        );

        const partsStoraUrl = prefooterLinksResult
            ?.filter((item: { name: string }) => item.name == "MyK_PreFooter_Parts")[0]
            ?.children?.filter(
                (c: { name: string }) => c.name == "MyK_PreFooter_Parts_OrderParts"
            )[0]?.fullurl;
        window.location = isGuestUser ? guestUserUrlLink?.mvcGuestUserPartStoreUrl : partsStoraUrl;
    }

    function _onBreadcrumbItemClicked(item: any) {
        navigate({
            pathname:"/myFleet",
        });
        dispatchsetBreadCrumRedirect(false);
        window.scrollTo(0, 0);
    }

    function _onBreadcrumbOHItemClicked(item: any) {
        navigate({
            pathname:  "/orderhistory",
        });
        window.scrollTo(0, 0);
        dispatchsetBreadCrumRedirect(false);        
    }

    return (
        <BreadCrumbs showKomatsuCreditHistory={props.showKomatsuCreditHistory} getMachineManufacturePunchoutButton={props?.getMachineManufacturePunchoutButton}
            clearMachineManufacturePunchoutButton={props?.clearMachineManufacturePunchoutButton} pageName={props.pageName} showPuchoutHistory={props.showPuchoutHistory} isCheckoutPage={props.isCheckoutPage} shoppingcartOnClick={props.shoppingcartOnClick} setCartDetails={props?.setCartDetails} isPriceAndAvailabilityRequired={props?.isPriceAndAvailabilityRequired} setIsPriceAndAvailabilityRequired={props?.setIsPriceAndAvailabilityRequired} breadcrumItems={breadcrumItems} />
    )
}
export default BreadCrumbsContainer